import React, { useContext, useState } from "react";
import { 
  Button, 
  Flex, 
  Input, 
  Text, 
  useMediaQuery 
} from "@chakra-ui/react";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import "./ResetPassword.css";

const ResetPassword = () => {
  const [isLargerThan800] = useMediaQuery("(min-width: 800px)");
  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  
  const [data, setData] = useState({
    senhaAntiga: "",
    senhaNova: "",
    confirmarSenhaNova: ""
  });
  
  const [errors, setErrors] = useState({});

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {
    // Validação
    let errorsTemp = {};
    if (data.senhaAntiga.trim() === "") {
      errorsTemp.senhaAntiga = "Este campo é obrigatório";
    }

    if (data.senhaNova.trim() === "") {
      errorsTemp.senhaNova = "Este campo é obrigatório";
    } else if (data.senhaNova.trim().length < 6) {
      errorsTemp.senhaNova = "A senha deve possuir no mínimo 6 dígitos";
    }

    if (data.confirmarSenhaNova.trim() === "") {
      errorsTemp.confirmarSenhaNova = "Este campo é obrigatório";
    } else if (data.confirmarSenhaNova !== data.senhaNova) {
      errorsTemp.confirmarSenhaNova = "As senhas não coincidem";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/trocar-senha`,
        {
          senhaAntiga: data.senhaAntiga,
          senhaNova: data.senhaNova
        },
        {
          headers: {
            "x-access-token": authInfo?.dataUser?.token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        setNotiMessage({
          type: "success",
          message: "Senha alterada com sucesso!",
        });
        // Limpar o formulário após a alteração bem-sucedida
        setData({
          senhaAntiga: "",
          senhaNova: "",
          confirmarSenhaNova: ""
        });
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response?.status)) {
          setNotiMessage({
            type: "error",
            message: "A sua sessão expirou, para continuar faça login novamente.",
          });
        } else if (err.response?.status === 400) {
          setNotiMessage({
            type: "error",
            message: err.response?.data?.error || "Senha antiga incorreta",
          });
          setErrors((prev) => ({
            ...prev,
            senhaAntiga: "Senha antiga incorreta",
          }));
        } else {
          setNotiMessage({
            type: "error",
            message: "Um erro ocorreu ao alterar a senha",
          });
        }
      });
  };

  //deixar os inputs na horizontal 
  return (
    <div
      className="Perfil_container"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "95vh",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div className="Perfil_header" style={{ width: "100%" }}>
        <div className="Perfil_header_left">
          <div className="Perfil_header_title" style={{ color: "white" }}>
            Resetar Senha
          </div>
        </div>
      </div>

      <Flex
        direction="column"
        width={isLargerThan800 ? "400px" : "100%"}
        backgroundColor="#1F2630"
        padding="30px"
        borderRadius="20px"
        marginTop="30px"
        border="1px solid white"
      >
        <Text fontSize="20px" fontWeight="bold" color="white" marginBottom="20px" textAlign="center">
          Alterar Senha
        </Text>

        <div className="Perfil_itemField">
          <label
            className="Perfil_itemFieldLabel"
            htmlFor="senhaAntiga"
            style={{ color: "white" }}
          >
            Senha antiga:
          </label>
          <Input
            placeholder="Digite sua senha atual"
            value={data.senhaAntiga}
            id="senhaAntiga"
            type="password"
            name="senhaAntiga"
            autoComplete="current-password"
            onChange={(event) => {
              handleChange("senhaAntiga", event.target.value);
            }}
            className={`${!!errors.senhaAntiga ? "Perfil_inputError" : ""}`}
          />
          {errors.senhaAntiga && (
            <div className="Perfil_itemFieldError">{errors.senhaAntiga}</div>
          )}
        </div>

        <div className="Perfil_itemField">
          <label
            className="Perfil_itemFieldLabel"
            htmlFor="senhaNova"
            style={{ color: "white" }}
          >
            Senha nova:
          </label>
          <Input
            placeholder="Digite sua nova senha"
            value={data.senhaNova}
            id="senhaNova"
            type="password"
            name="senhaNova"
            autoComplete="new-password"
            onChange={(event) => {
              handleChange("senhaNova", event.target.value);
            }}
            className={`${!!errors.senhaNova ? "Perfil_inputError" : ""}`}
          />
          {errors.senhaNova && (
            <div className="Perfil_itemFieldError">{errors.senhaNova}</div>
          )}
        </div>

        <div className="Perfil_itemField">
          <label
            className="Perfil_itemFieldLabel"
            htmlFor="confirmarSenhaNova"
            style={{ color: "white" }}
          >
            Confirmar senha nova:
          </label>
          <Input
            placeholder="Confirme sua nova senha"
            value={data.confirmarSenhaNova}
            id="confirmarSenhaNova"
            type="password"
            name="confirmarSenhaNova"
            autoComplete="new-password"
            onChange={(event) => {
              handleChange("confirmarSenhaNova", event.target.value);
            }}
            className={`${!!errors.confirmarSenhaNova ? "Perfil_inputError" : ""}`}
          />
          {errors.confirmarSenhaNova && (
            <div className="Perfil_itemFieldError">{errors.confirmarSenhaNova}</div>
          )}
        </div>

        <Button
          className="Perfil_saveBtn"
          onClick={() => {
            if (!isLoading) onSave();
          }}
          disabled={isLoading}
          colorScheme="blue"
          marginTop="30px"
          isLoading={isLoading}
          loadingText="Salvando..."
        >
          ALTERAR SENHA
        </Button>
      </Flex>
    </div>
  );
};

export default ResetPassword;